import { createSearchParams, useNavigate } from "react-router-dom";

// Components
import NavigationButton from "components/atoms/NavigationButton";

// Constants
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";

// Icons
import LogoutIcon from "assets/icons/glory/burger_logout.svg?react";

import "./styles.sass";

const LogoutBlock = () => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    navigate({
      search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.logoutConfirm })}`,
    });
  };

  return (
    <div className="LogoutBlock">
      <NavigationButton
        name="menu.left.logout"
        icon={<LogoutIcon />}
        // eslint-disable-next-line react/jsx-handler-names
        onClick={onClickHandler}
      />
    </div>
  );
};

export default LogoutBlock;
